export default __webpack_public_path__ + "static/media/modalBuddies.8a6575da.png";